export function capitalizeFirst(str: string | null | undefined): string {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function formatBirthdate(dateStr: string | null | undefined): string {
  if (!dateStr) return "N/A";
  
  // Parse date string manually to avoid timezone issues
  let date: Date;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    // YYYY-MM-DD format - parse manually to avoid timezone issues
    const [year, month, day] = dateStr.split('-').map(Number);
    date = new Date(year, month - 1, day);
  } else {
    date = new Date(dateStr);
  }
  
  if (Number.isNaN(date.getTime())) return "N/A";
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}

export function formatDate(timestamp: number | null | string): string {
  if (!timestamp) return "-----";

  const date =
    typeof timestamp === "number" ? new Date(timestamp * 1000) : new Date(timestamp);

  return date.toLocaleDateString();
}

export function formatDateTime(timestamp: number | null | string): string {
  if (!timestamp) return "-----";

  const date =
    typeof timestamp === "number" ? new Date(timestamp * 1000) : new Date(timestamp);

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}

export function generatePaginationItems(
  totalPages: number,
  currentPage: number,
  maxVisiblePages = 7
): (number | string)[] {
  const halfVisible = Math.floor(maxVisiblePages / 2);

  if (totalPages <= maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const generateRange = (start: number, end: number): number[] =>
    Array.from({ length: end - start + 1 }, (_, i) => start + i);

  const items: (number | string)[] = [1];

  if (currentPage <= halfVisible + 2) {
    const middlePages = generateRange(2, maxVisiblePages - 1);
    return [...items, ...middlePages, "...", totalPages];
  } else if (currentPage >= totalPages - halfVisible - 1) {
    const endPages = generateRange(totalPages - maxVisiblePages + 2, totalPages);
    return [...items, "...", ...endPages];
  } else {
    const middlePages = generateRange(currentPage - halfVisible, currentPage + halfVisible);
    return [...items, "...", ...middlePages, "...", totalPages];
  }
}

